import React from "react";
import { Link } from "react-router-dom";
import { Fade } from "react-reveal";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import { products } from "../../portfolio";
import "./Products.css";

export default function Products({ theme, embedded }) {
  const Root = embedded ? "section" : "div";
  const Content = embedded ? "div" : "main";

  return (
    <Root
      id={embedded ? "products" : undefined}
      className={`products-page site-scroll-section${
        embedded ? " embedded-section" : ""
      }`}
    >
      {!embedded && <Header theme={theme} />}
      <Content className="products-content">
        <Fade bottom duration={900} distance="30px">
          <header className="products-heading">
            <span
              className="iconify products-heading-icon"
              data-icon="mdi:package-variant-closed"
              data-inline="false"
              aria-hidden="true"
            ></span>
            <h1 style={{ color: theme.text }}>{products.title}</h1>
          </header>
        </Fade>

        {products.items.length > 0 ? (
          <div className="products-grid">
            {products.items.map((product) => (
              <Link
                className="product-card"
                to={`/products/${product.slug}`}
                key={product.slug}
                style={{ backgroundColor: theme.highlight }}
              >
                {product.logo ? (
                  <img
                    className="product-card-logo"
                    src={product.logo}
                    alt=""
                    width="72"
                    height="72"
                    loading="lazy"
                  />
                ) : (
                  product.icon && (
                    <span
                      className="iconify product-card-icon"
                      data-icon={product.icon}
                      data-inline="false"
                      aria-hidden="true"
                    ></span>
                  )
                )}
                <h2 style={{ color: theme.text }}>{product.name}</h2>
                <p style={{ color: theme.secondaryText }}>
                  {product.description}
                </p>
              </Link>
            ))}
          </div>
        ) : (
          <Fade bottom duration={1000} distance="24px">
            <section
              className="products-empty-state"
              style={{ backgroundColor: theme.highlight }}
            >
              <span
                className="iconify products-empty-icon"
                data-icon="mdi:progress-clock"
                data-inline="false"
                aria-hidden="true"
              ></span>
              <h2 style={{ color: theme.text }}>{products.emptyState}</h2>
            </section>
          </Fade>
        )}
      </Content>
      {!embedded && (
        <>
          <Footer theme={theme} />
          <TopButton theme={theme} />
        </>
      )}
    </Root>
  );
}
